const angular = require('angular');

const ExpressService = require('./express.service');
const { expressAddressPanelControllerComponentDefinition } = require('./express-address-panel.component');
const { expressAddressAvailabilityControllerComponentDefinition } = require('./express-address-availability.component');
const { expressCartItemCountControllerComponentDefinition } = require('./express-cart-item-count.component');
const { expressSelectedDialogControllerComponentDefinition } = require('./dialog/express-selected-dialog.component');
const { expressSelectedDialogContentControllerComponentDefinition } = require('./dialog/express-selected-dialog-content.component');

angular.module('wowApp.shop')
    .component('wowExpressAddressPanel', expressAddressPanelControllerComponentDefinition)
    .component('wowExpressAddressAvailability', expressAddressAvailabilityControllerComponentDefinition)
    .component('wowExpressCartItemCount', expressCartItemCountControllerComponentDefinition)
    .component('wowExpressSelectedDialog', expressSelectedDialogControllerComponentDefinition)
    .component('wowExpressSelectedDialogContent', expressSelectedDialogContentControllerComponentDefinition)
    .service('ExpressService', ['Restangular', 'LocalStorageWrapper', ExpressService]);



// WEBPACK FOOTER //
// ./src/shop/express/index.js